import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from ".././../../../assets/icons/search-normal.svg"

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const MAX_HISTORY = 5; // Max history to show is set to 5

const SearchBar = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [results, setResults] = useState([]);
  const [searchHistory, setSearchHistory] = useState([]);
  const navigate = useNavigate();

   // Fetch Stored SearchHistory in LocalStorage
   useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("searchHistory")) || [];
    setSearchHistory(saved);
  }, []);

   // Store SearchHistory in LocalStorage
   const saveSearchHistory = (project) => {
    const updated = [project, ...searchHistory.filter((p) => p.id !== project.id)].slice(0, MAX_HISTORY);
    setSearchHistory(updated);
    localStorage.setItem("searchHistory", JSON.stringify(updated));
  };

  const fetchSearchResults = async (query) => {
    if (!query) {
      setShowDropdown(true); // Show Search History
      setResults([]);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${BACKEND_URL}/search?query=${query}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) throw new Error(`Error: ${response.statusText}`);
      const data = await response.json();

      if (data.results.length === 0) {
        setError("No projects found.");
      } else {
        setResults(data.results);
      }

      setShowDropdown(true);
    } catch (error) {
      console.error("❌ Search API error:", error);
      setError("Something went wrong. Please try again.");
      setShowDropdown(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (!query.trim()) {
      setShowDropdown(false);
      setResults([]);
      return;
    }

    setTimeout(() => fetchSearchResults(query), 500);
  };

  const handleProjectClick = (projectOrId) => {
    const project =
      typeof projectOrId === "object" ? projectOrId : results.find(p => p.id === projectOrId);

    if (!project) return;

    saveSearchHistory(project); // save the full project object to history
    navigate(`/projects/${project.id}/details`);
    setShowDropdown(false);
  };


  return (
    <div className="relative w-full max-w-[525px] h-11 bg-neutral-100 rounded-[10px] border border-gray-300 flex items-center px-3">
      <img src={SearchIcon} alt="Search" className="w-5 h-5 mr-2" />

      <input
  type="text"
  value={searchQuery}
  onChange={handleSearchChange}
  onFocus={() => setShowDropdown(true)}
  onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
  placeholder="Search for a project..."
  className="flex-1 bg-transparent outline-none text-sm text-gray-800 placeholder-zinc-500 font-inter placeholder:sm:opacity-100 placeholder:opacity-0"
/>


      {showDropdown && (
        <div className="absolute top-full left-0 w-full mt-2 bg-white border border-blue-200 rounded-xl shadow-lg z-50 p-3 animate-fadeIn max-h-60 overflow-y-auto">
          {loading ? (
            <div className="text-center font-bold text-blue-600 py-2">Searching...</div>
          ) : error ? (
            <div className="text-center font-bold text-red-500 py-2">{error}</div>
          ) : searchQuery.trim() ? (
            results.map((project) => (
              <div
                key={project.id}
                onClick={() => handleProjectClick(project.id)}
                className="flex items-center gap-3 p-2 border-b border-gray-200 cursor-pointer hover:bg-gray-50 transition"
              >
                <img
                  src={project.image}
                  alt={project.name}
                  className="w-8 h-8 rounded-md object-cover"
                />
                <div className="truncate">
                  <p className="font-semibold text-sm truncate">{project.name}</p>
                  <p className="text-xs text-gray-500 truncate">{project.oneLiner}</p>
                </div>
              </div>
            ))
          ) : (
            <>
              <p className="text-xs text-gray-400 px-2 pb-1">Recent Searches</p>
              {searchHistory.length > 0 ? (
                searchHistory.map((project) => (
                  <div
                    key={project.id}
                    onClick={() => handleProjectClick(project)}
                    className="flex items-center gap-3 p-2 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition"
                  >
                    <img
                      src={project.image}
                      alt={project.name}
                      className="w-8 h-8 rounded-md object-cover"
                    />
                    <div className="truncate">
                      <p className="font-semibold text-sm truncate">{project.name}</p>
                      <p className="text-xs text-gray-500 truncate">{project.oneLiner}</p>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-sm text-gray-400 py-2">No search history yet.</p>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchBar;
